export const setLabelPrinterDevice = (device) => ({
  type: 'SET_LABEL_PRINTER_DEVICE',
  payload: device,
});
